module.exports = __webpack_public_path__ + "img/3.31f48e63.jpg";